import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { Agent } from "@/types";

// #224R: Owner-Whitelist setzen. PATCH /agents/:id/model-policy (admin-only). Der
// Admin-FIX läuft NICHT hierüber, sondern über die Config-API (usePatchManaged →
// config.managed.model). Invalidiert ["resources","agents"] → Agent-Detail refresht.

function useModelPolicyClient() {
  const { session, logout } = useAuth();
  return () =>
    createApiClient({
      getToken: () => session?.accessToken ?? null,
      onUnauthorized: logout,
    });
}

export interface ModelPolicyPatch {
  allowedModels?: string[];
  // #P001 (UC-3): Kontext-Defaults — Patch pro Key (fehlt = unverändert, null = löschen).
  defaults?: { chat?: string | null; case?: string | null };
}

export function useUpdateModelPolicy(
  agentId: string,
): UseMutationResult<Agent, Error, ModelPolicyPatch> {
  const qc = useQueryClient();
  const getClient = useModelPolicyClient();
  return useMutation({
    mutationFn: (patch) => getClient().patch<Agent>(`/agents/${agentId}/model-policy`, patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.resource("agents") }),
  });
}
